import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-legend-1-6-0{display:block;padding-bottom:2px;color:#757575;font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:300}",
map:{"hcr-legend":"hcr-legend-1-6-0"}};

var bem = Bem('legend', styles);
var Legend = function Legend(_ref) {
  var extraClasses = _ref.extraClasses,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "children"]);

  return React.createElement("legend", _extends({
    className: bem.b(false, extraClasses)
  }, rest), children);
};
Legend.displayName = 'Legend';
Legend.defaultProps = {
  extraClasses: ''
};
Legend.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Children */
  children: PropTypes.node.isRequired
};
var legend = Injecss(Legend, styles);

export { legend as Legend };
